import React from 'react';
import { connect } from "react-redux";
import "react-table/react-table.css";
import Navbar from '../NavBar/navBar'
import { faPencilAlt, faSave, faArrowsAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { Input, Col, Row, Button } from 'reactstrap';
import Tour from '../../Tour';
import './dashboard.css';
import "react-datepicker/dist/react-datepicker.css";
import { reactPlugin } from "../../AppInsights";
import { safeWithAITracking } from "../../utils/safeAITracking";
import {
    fetchSampleCount,
    fetchBuilding,
    fetchFloors,
    fetchUserProfile,
    saveUserProfile,
    updateUserProfile,
    fetchLocationTrend

} from '../../actions';

import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from 'react-toastify';
import jwt_decode from "jwt-decode";
import ShowcaseLayout from "./dashboardGrid";
import HeatmapPreview from './heatmapPreview';
import _ from "lodash";


const colors = ['#f58026', '#0f61f5', '#00d168', '#7548c7', '#f53a1b']

let user;
class Dashboard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            SamplesPeriod: "",
            CTPeriod: "",
            filterType: "complex_type",
            building: "",
            buildingId: "",
            fromDate: "",
            toDate: "",
            startDateLeft: "",
            startDateRight: "",
            endDate: "",
            dateSelectedLeft: false,
            dateSelectedRight: false,
            complex_period: "",
            seq_period: "",
            windowWidth: window.innerWidth,
            speciesStartDate: "",
            speciesEndDate: "",
            speciesMonth: "",
            speciesYear: "",
            biome_period: "",
            canEdit: false,
            newLayout: null,
            newUser: true,
            mounted: false,
            initialLayouts: {
                lg: [
                    { "x": 0, "y": 0, "w": 2, "h": 5, "i": 'samples-collected', "static": false },
                    { "x": 8, "y": 0, "w": 4, "h": 5, "i": 'type-of-analysis', "static": false },
                    { "x": 6, "y": 5, "w": 6, "h": 14, "i": 'sample-result-distro-graph', "static": false },
                    { "x": 0, "y": 15, "w": 6, "h": 14, "i": 'abundance-species-graph', "static": false },
                    { "x": 6, "y": 15, "w": 6, "h": 9, "i": 'recent-activity-table', "static": false },
                    { "x": 0, "y": 30, "w": 6, "h": 8, "i": "status-amostra", "static": false },
                    { "x": 6, "y": 30, "w": 6, "h": 8, "i": "avaliacao", "static": false },
                    { "x": 0, "y": 38, "w": 6, "h": 10, "i": "nome-teste", "static": false },
                    { "x": 6, "y": 38, "w": 6, "h": 10, "i": "sala", "static": false },
                    { "x": 0, "y": 48, "w": 6, "h": 10, "i": "numerical-value-chart", "static": false },
                    { "x": 6, "y": 48, "w": 6, "h": 10, "i": "sample-description", "static": false },
                    { "x": 0, "y": 62, "w": 12, "h": 14, "i": "heatmap-preview", "static": false },
                ],
                lm: [
                    { "x": 0, "y": 0, "w": 4, "h": 4, "i": 'samples-collected', "static": false },
                    { "x": 4, "y": 0, "w": 8, "h": 4, "i": 'type-of-analysis', "static": false },
                    { "x": 8, "y": 6, "w": 6, "h": 14, "i": 'sample-result-distro-graph', "static": false },
                    { "x": 0, "y": 16, "w": 6, "h": 14, "i": 'abundance-species-graph', "static": false },
                    { "x": 6, "y": 16, "w": 6, "h": 9, "i": 'recent-activity-table', "static": false },
                    { "x": 0, "y": 30, "w": 6, "h": 8, "i": "status-amostra", "static": false },
                    { "x": 6, "y": 30, "w": 6, "h": 8, "i": "avaliacao", "static": false },
                    { "x": 0, "y": 38, "w": 6, "h": 10, "i": "nome-teste", "static": false },
                    { "x": 6, "y": 38, "w": 6, "h": 10, "i": "sala", "static": false },
                    { "x": 0, "y": 48, "w": 6, "h": 10, "i": "numerical-value-chart", "static": false },
                    { "x": 6, "y": 48, "w": 6, "h": 10, "i": "sample-description", "static": false },
                    { "x": 0, "y": 62, "w": 12, "h": 14, "i": "heatmap-preview", "static": false },
                ],
                md: [
                    { "x": 0, "y": 0, "w": 2, "h": 5, "i": 'samples-collected', "static": false },
                    { "x": 6, "y": 0, "w": 4, "h": 5, "i": 'type-of-analysis', "static": false },
                    { "x": 5, "y": 5, "w": 5, "h": 14, "i": 'sample-result-distro-graph', "static": false },
                    { "x": 0, "y": 15, "w": 5, "h": 14, "i": 'abundance-species-graph', "static": false },
                    { "x": 5, "y": 15, "w": 5, "h": 9, "i": 'recent-activity-table', "static": false },
                    { "x": 0, "y": 30, "w": 5, "h": 8, "i": "status-amostra", "static": false },
                    { "x": 5, "y": 30, "w": 5, "h": 8, "i": "avaliacao", "static": false },
                    { "x": 0, "y": 38, "w": 5, "h": 10, "i": "nome-teste", "static": false },
                    { "x": 5, "y": 38, "w": 5, "h": 10, "i": "sala", "static": false },
                    { "x": 0, "y": 48, "w": 5, "h": 10, "i": "numerical-value-chart", "static": false },
                    { "x": 5, "y": 48, "w": 5, "h": 10, "i": "sample-description", "static": false },
                    { "x": 0, "y": 62, "w": 10, "h": 14, "i": "heatmap-preview", "static": false },
                ],
                sm: [
                    { "x": 0, "y": 0, "w": 2, "h": 5, "i": 'samples-collected', "static": false },
                    { "x": 2, "y": 0, "w": 4, "h": 5, "i": 'type-of-analysis', "static": false },
                    { "x": 0, "y": 20, "w": 6, "h": 14, "i": 'sample-result-distro-graph', "static": false },
                    { "x": 0, "y": 30, "w": 6, "h": 14, "i": 'abundance-species-graph', "static": false },
                    { "x": 0, "y": 40, "w": 6, "h": 9, "i": 'recent-activity-table', "static": false },
                    { "x": 0, "y": 50, "w": 6, "h": 10, "i": "status-amostra", "static": false },
                    { "x": 0, "y": 60, "w": 6, "h": 10, "i": "avaliacao", "static": false },
                    { "x": 0, "y": 70, "w": 6, "h": 12, "i": "nome-teste", "static": false },
                    { "x": 0, "y": 82, "w": 6, "h": 10, "i": "numerical-value-chart", "static": false },
                    { "x": 0, "y": 96, "w": 6, "h": 10, "i": "sample-description", "static": false },
                    { "x": 0, "y": 110, "w": 6, "h": 12, "i": "sala", "static": false },
                    { "x": 0, "y": 122, "w": 6, "h": 14, "i": "heatmap-preview", "static": false },
                ],
                xs: [
                    { "x": 0, "y": 0, "w": 4, "h": 5, "i": 'samples-collected', "static": false },
                    { "x": 0, "y": 15, "w": 4, "h": 5, "i": 'type-of-analysis', "static": false },
                    { "x": 0, "y": 30, "w": 5, "h": 14, "i": 'sample-result-distro-graph', "static": false },
                    { "x": 0, "y": 40, "w": 5, "h": 14, "i": 'abundance-species-graph', "static": false },
                    { "x": 0, "y": 50, "w": 5, "h": 9, "i": 'recent-activity-table', "static": false },
                    { "x": 0, "y": 60, "w": 4, "h": 10, "i": "status-amostra", "static": false },
                    { "x": 0, "y": 70, "w": 4, "h": 10, "i": "avaliacao", "static": false },
                    { "x": 0, "y": 80, "w": 4, "h": 12, "i": "nome-teste", "static": false },
                    { "x": 0, "y": 92, "w": 4, "h": 10, "i": "numerical-value-chart", "static": false },
                    { "x": 0, "y": 106, "w": 4, "h": 10, "i": "sample-description", "static": false },
                    { "x": 0, "y": 120, "w": 4, "h": 12, "i": "sala", "static": false },
                    { "x": 0, "y": 132, "w": 4, "h": 14, "i": "heatmap-preview", "static": false },
                ],
            },
            originalLayout: {},
            resetLayout: false
        }

        if (localStorage.getItem("auth_token")) {
            user = jwt_decode(localStorage.getItem("auth_token"));
        }
        this.saveUserPreferences = this.saveUserPreferences.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.resetHandler = this.resetHandler.bind(this);
        this.resetGridLayout = this.resetGridLayout.bind(this);

    }

    handleWindowResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    async componentDidMount() {
        if (!localStorage.getItem("guest")) {
            await this.props.fetchUserProfile().then((response) => {
                if ((this.props.userProfile.length > 0)) {
                    if (this.props.userProfile[0]['user_preferences']) {
                        if (this.props.userProfile[0]['user_preferences']['dashboard_layout']) {
                            this.setState({
                                originalLayout: { ...this.props.userProfile[0]['user_preferences']['dashboard_layout'] },
                                initialLayouts: { ...this.props.userProfile[0]['user_preferences']['dashboard_layout'] }
                            })
                            this.setState({ newUser: false })
                        }
                    }
                }
            });
        }

        window.addEventListener('resize', this.handleWindowResize);
        this.setState({
            endDate: moment(new Date()).format('DD MMM YYYY')
        })
        this.setState({ mounted: true })

        this.handleVisibilityChange = () => {
            if (!document.hidden) {
                this.props.fetchSampleCount({});
            }
        };
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    componentWillUnmount() {
        this.setState({ mounted: false })
        window.removeEventListener('resize', this.handleWindowResize);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    onLayoutChange(layout, layouts) {
        this.setState({ newLayout: layouts });

    }

    saveUserPreferences(event, layoutChanged) {
        if (layoutChanged == 'save' && !_.isEqual(this.state.newLayout, this.state.originalLayout)) {
            //Save User Preferences
            if (localStorage.getItem("guest")) {
                //Guest Login
                let message = "Guest prefereneces cannot be saved!";
                toast.info(message, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            }
            else {
                if (this.state.newUser) {
                    let data = {
                        'email_id': user.unique_name,
                        'user_preferences': {
                            'dashboard_layout': this.state.newLayout,
                            'updated_at': moment().format('MMM D, YYYY HH:mm')
                        }
                    }
                    this.props.saveUserProfile(data).then((response) => {
                        let message = "Your dashboard prefereneces has been saved successfully!";
                        toast.success(message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                        this.setState({
                            originalLayout: this.state.newLayout,
                            initialLayouts: this.state.newLayout,
                            newUser: false,
                        });

                    }).catch((response) => {
                        let message = "Problem while saving dashboard preferences";
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                    });
                }
                else {
                    let data = {
                        id: this.props.userProfile[0].id,
                        email_id: user.unique_name,
                        user_preferences: {
                            'dashboard_layout': this.state.newLayout,
                            'updated_at': moment().format('MMM D, YYYY HH:mm')
                        }
                    }

                    this.props.updateUserProfile(data).then((response) => {
                        if (response.status === 200) {
                            let message = "Your dashboard prefereneces has been saved successfully!";
                            toast.success(message, {
                                position: toast.POSITION.BOTTOM_RIGHT,
                            });
                            this.setState({
                                originalLayout: this.state.newLayout,
                                initialLayouts: this.state.newLayout
                            });
                        } else {
                            let message = "Problem while saving dashboard preferences";
                            toast.error(message, {
                                position: toast.POSITION.BOTTOM_RIGHT,
                            });
                        }
                    });
                }
            }
        }
        else if (layoutChanged == 'save' && this.state.newLayout && _.isEqual(this.state.newLayout, this.state.originalLayout)) {
            let message = "No new dashboard changes made";
            toast.info(message, {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        }
        else if (layoutChanged == 'cancel') {
            this.resetGridLayout();
        }
        this.setState({
            canEdit: !this.state.canEdit
        });
    }

    resetHandler() {
        this.setState({
            resetLayout: false
        })
    }

    restoreGridLayouts = gridLayouts => {
        this.setState({
            originalLayout: gridLayouts,
        });
    };

    resetGridLayout = () => {
        // Layouts get re-rendered only when the number of layouts changes rather than data-grid items receiving manipulations
        const dummy = { ...this.state.initialLayouts };
        dummy.lg = [...dummy.lg, {
            i: 'dummy-lg',
            x: 0,
            y: 0,
            w: 0,
            h: 0
        }];
        dummy.lm = [...dummy.lm, {
            i: 'dummy-lm',
            x: 0,
            y: 0,
            w: 0,
            h: 0
        }];
        dummy.md = [...dummy.md, {
            i: 'dummy-md',
            x: 0,
            y: 0,
            w: 0,
            h: 0
        }];
        dummy.sm = [...dummy.sm, {
            i: 'dummy-sm',
            x: 0,
            y: 0,
            w: 0,
            h: 0
        }];
        dummy.xs = [...dummy.xs, {
            i: 'dummy-xs',
            x: 0,
            y: 0,
            w: 0,
            h: 0
        }];
        this.restoreGridLayouts(dummy);

        setTimeout(() => {
            this.restoreGridLayouts({ ...this.state.initialLayouts });
        }, 0);
    }

    render() {
        let windowWidth = this.state.windowWidth;
        let ogLayout = this.state.originalLayout;
        return (
            <>
                <div className="page-layout">
                    <Navbar />
                    <div className="dashboard-overview" data-tut="reactour__dashboardPage">
                        <Row className="dashboard-header" style={{ justifyContent: 'flex-end', gap: '10px', alignItems: 'center' }}>
                            {!this.state.canEdit ?
                                <>{windowWidth > 485 ?
                                    <Button className="dashboard-edit-button" onClick={(event) => this.saveUserPreferences(event, 'edit')}>
                                        <FontAwesomeIcon className="dashboard-edit-icon" icon={faPencilAlt}></FontAwesomeIcon>
                                        {windowWidth > 750 ? <span>Edit Dashboard</span> : <span>Edit</span>}
                                    </Button> :
                                    <Button className="dashboard-edit-button rounded-circle" onClick={(event) => this.saveUserPreferences(event, 'edit')}>
                                        <FontAwesomeIcon className="dashboard-edit-icon dashboard-edit-icon-sm-align " icon={faPencilAlt} onClick={(event) => this.saveUserPreferences(event, 'edit')}></FontAwesomeIcon>
                                    </Button>}
                                </>
                                :
                                <>{windowWidth > 485 ?
                                    <>
                                        <Button className="dashboard-save-button" onClick={(event) => this.saveUserPreferences(event, 'save')}>
                                            <FontAwesomeIcon className="dashboard-save-icon" icon={faSave}></FontAwesomeIcon>
                                            <span>Save</span>
                                        </Button>
                                        <Button className="dashboard-cancel-button" onClick={(event) => this.saveUserPreferences(event, 'cancel')}>
                                            <FontAwesomeIcon className="dashboard-cancel-icon" icon={faTimes}></FontAwesomeIcon>
                                            <span>Cancel</span>
                                        </Button>
                                    </> :
                                    <>
                                        <Button className="dashboard-save-button rounded-circle" onClick={(event) => this.saveUserPreferences(event, 'save')}>
                                            <FontAwesomeIcon className="dashboard-save-icon dashboard-edit-icon-sm-align" icon={faSave}></FontAwesomeIcon>
                                        </Button>
                                        <Button className="dashboard-cancel-button rounded-circle" onClick={(event) => this.saveUserPreferences(event, 'cancel')}>
                                            <FontAwesomeIcon className="dashboard-cancel-icon dashboard-edit-icon-sm-align" icon={faTimes}></FontAwesomeIcon>
                                        </Button>
                                    </>
                                }
                                </>
                            }

                        </Row>
                        <div className="" >
                            {this.state.mounted ?
                                <ShowcaseLayout
                                    onLayoutChange={this.onLayoutChange}
                                    canEdit={this.state.canEdit}
                                    initialLayout={Object.keys(ogLayout).length ? ogLayout : this.state.initialLayouts}
                                    dashboardData={this.props.dashboardData}
                                    buildingList={this.props.buildingList}
                                    floorsList={this.props.floorsList}
                                    resetLayout={this.state.resetLayout}
                                    resetHandler={this.resetHandler}
                                    windowWidth={this.state.windowWidth}
                                    fetchSampleCount={this.props.fetchSampleCount}
                                    fetchFloors={this.props.fetchFloors}
                                    fetchLocationTrend={this.props.fetchLocationTrend}
                                    locationTrendData={this.props.locationTrendData}
                                /> : null}
                        </div>
                        <ToastContainer autoClose={3000} />
                        {this.props.isTourOpen ? <Tour isOpen={this.props.isTourOpen} closeTour={this.props.closeTour} openTour={this.props.openTour} /> : null}
                    </div>
                </div>
            </>
        )
    }
}


const mapStateToProps = state => {
    return {
        dashboardData: state.sample_data.dashboardData,
        buildingList: state.floor_data.buildingsList,
        floorsList: state.floor_data.floorsList,
        userProfile: state.dashboard_data.userProfile,
        locationTrendData: state.sample_data.locationTrendData,
    }
}

export default safeWithAITracking(reactPlugin, connect(
    mapStateToProps,
    {
        fetchSampleCount,
        fetchBuilding,
        fetchFloors,
        fetchUserProfile,
        saveUserProfile,
        updateUserProfile,
        fetchLocationTrend
    }
)(Dashboard), 'Dashboard', 'Dashboard');
